import { API_GATEWAY_ROOT } from "@danishagro/shared/src/constants/urlRoot.constants";
import { DA_SharedGlobalVariables } from "../interfaces/sharedGlobalVariables.interface";
import { getBearerToken, getBearerTokenB2C } from "./getBearerToken.helper";
import { isDevMode } from "./isDevMode.helper";

export const getSharedGlobalVariables = (
    forceNew = false,
    siteVariant?: string
): Promise<DA_SharedGlobalVariables> =>
    new Promise((resolve, reject) => {
        const isAdmin = typeof globalThis.isAdmin === "boolean" ? globalThis.isAdmin : isDevMode;
        const isImpersonator =
            typeof globalThis.isImpersonator === "boolean" ? globalThis.isImpersonator : isDevMode;
        const isMasterAdmin =
            typeof globalThis.isMasterAdmin === "boolean" ? globalThis.isMasterAdmin : isDevMode;
        const newPageData =
            typeof globalThis.newPageContent !== "undefined" ? globalThis.newPageContent : null;

        const baseVariables = {
            isAdmin,
            isMasterAdmin,
            isImpersonator,
            newPageData,
        };

        // Prefer explicit param, fallback to globalThis
        const currentSiteVariant = siteVariant;

        // Tokken
        const getToken =
            currentSiteVariant === "hatting-agro-b2b" ? getBearerTokenB2C : getBearerToken;

        (globalThis.isAuthenticated ? getToken() : Promise.reject())
            .then((accessToken) => {
                if (typeof accessToken !== "string") {
                    return reject("no token");
                }
                const getCvrAndCustomerNumbers =
                    globalThis.cvrAndCustomerNumbers && !forceNew
                        ? Promise.resolve(globalThis.cvrAndCustomerNumbers)
                        : !accessToken
                        ? Promise.resolve()
                        : fetch(
                              currentSiteVariant === "hatting-agro-b2b"
                                  ? `${API_GATEWAY_ROOT}/api/user/getuseraccounts`
                                  : `${API_GATEWAY_ROOT}/user/getuseraccounts`,
                              {
                                  credentials: "include",
                                  headers: {
                                      Authorization: "Bearer " + accessToken,
                                  },
                              }
                          )
                              .then((res) => res.json())
                              .catch(() => null);

                return getCvrAndCustomerNumbers
                    .then((cvrAndCustomerNumbers) => {
                        const variables: DA_SharedGlobalVariables = {
                            ...baseVariables,
                            cvrAndCustomerNumbers,
                        };

                        Object.keys(variables).forEach((key) => {
                            globalThis[key] = variables[key];
                        });

                        resolve(variables);
                    })
                    .catch((err) => reject(err));
            })
            .catch(() => {
                const variables = {
                    ...baseVariables,
                    cvrAndCustomerNumbers: undefined,
                };

                Object.keys(variables).forEach((key) => {
                    globalThis[key] = variables[key];
                });

                resolve(variables);
            });
    });
